export const BEFORE_APP_NAVIGATION_EVENT = "bri-before-app-navigation";

export type BeforeAppNavigationDetail = {
  nextPath: string;
  proceed: () => void;
};

export const canNavigateTo = (nextPath: string, proceed: () => void): boolean =>
  window.dispatchEvent(
    new CustomEvent<BeforeAppNavigationDetail>(BEFORE_APP_NAVIGATION_EVENT, {
      cancelable: true,
      detail: { nextPath, proceed },
    })
  );
